import React from 'react';

import { Theme } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    contentWrapper: {
      padding: `0px ${unit * 3}px`,
      height: 228,
      overflowY: 'scroll',
      overflowX: 'hidden',
    },
  });

interface FiltersListWrapperProps extends WithStyles<typeof styles> {}

const FiltersListWrapper: React.FC<FiltersListWrapperProps> = ({ children, classes }) => (
  <div className={classes.contentWrapper}>{children}</div>
);

export default withStyles(styles)(FiltersListWrapper);
